import type { AttendeeListFilter } from "@rekati/api";

/** Query keys, one place, so a write can invalidate exactly what it changed. */
export const keys = {
  brand: ["brand"] as const,
  event: ["event"] as const,
  frontdeskState: ["frontdesk", "state"] as const,
  overview: ["admin", "overview"] as const,
  arrivals: ["admin", "arrivals"] as const,
  registrations: ["admin", "registrations"] as const,
  adminSessions: ["admin", "sessions"] as const,
  demographics: ["admin", "demographics"] as const,
  attendees: (query: string, page: number, filter: AttendeeListFilter = {}) =>
    ["admin", "attendees", query, page, filter] as const,
  attendeesAll: ["admin", "attendees"] as const,
  aiStatus: ["admin", "ai", "status"] as const,
  industries: ["industries"] as const,
  record: (id: string) => ["superuser", "attendee", id] as const,
  staff: ["superuser", "staff"] as const,
  managedEvent: ["superuser", "event"] as const,
  managedSessions: ["superuser", "sessions"] as const,
  assets: ["superuser", "assets"] as const,
  taxonomies: ["superuser", "taxonomies"] as const,
  templates: (lang: string) => ["superuser", "templates", lang] as const,
  template: (key: string, lang: string) => ["superuser", "template", key, lang] as const,
  holds: ["superuser", "holds"] as const,
  campaigns: ["superuser", "campaigns"] as const,
  surveyQuestions: ["admin", "survey", "questions"] as const,
  surveySummary: (lang: string) => ["admin", "survey", "summary", lang] as const,
  surveyResponses: (lang: string) => ["admin", "survey", "responses", lang] as const,
};
